var map = {
	"./avatar.png": 74367,
	"./badge-nearby@1x.png": 62304,
	"./badge-nearby@2x.png": 43605,
	"./badge-nearby@3x.png": 78154,
	"./badge-nearby@4x.png": 43703,
	"./bg-buildings@1x.png": 62506,
	"./bg-buildings@2x.png": 45483,
	"./bg-buildings@3x.png": 71232,
	"./bg-buildings@4x.png": 42529,
	"./coupon.png": 39818,
	"./example@1x.png": 55389,
	"./example@2x.png": 54664,
	"./example@3x.png": 79891,
	"./example@4x.png": 74206,
	"./guide-change-mobile-1.png": 32800,
	"./guide-change-mobile-2.png": 87835,
	"./ic_creditcard@1x.png": 76705,
	"./ic_creditcard@2x.png": 12172,
	"./ic_creditcard@3x.png": 48439,
	"./ic_creditcard@4x.png": 96682,
	"./ic_creditcard_dark@1x.png": 64790,
	"./ic_creditcard_dark@2x.png": 50967,
	"./ic_creditcard_dark@3x.png": 14700,
	"./ic_creditcard_dark@4x.png": 22133,
	"./ic_edit@1x.png": 30710,
	"./ic_edit@2x.png": 33239,
	"./ic_edit@3x.png": 80620,
	"./ic_edit@4x.png": 4405,
	"./ic_edit_white@1x.png": 77320,
	"./ic_edit_white@2x.png": 78045,
	"./ic_edit_white@3x.png": 13042,
	"./ic_edit_white@4x.png": 9919,
	"./ic_sparkles@1x.png": 40437,
	"./ic_sparkles@2x.png": 18016,
	"./ic_sparkles@3x.png": 61419,
	"./ic_sparkles@4x.png": 48470,
	"./ic_sparkles_dark@1x.png": 23634,
	"./ic_sparkles_dark@2x.png": 74163,
	"./ic_sparkles_dark@3x.png": 92968,
	"./ic_sparkles_dark@4x.png": 75177,
	"./jid-logo-black.svg": 69947,
	"./jid-logo.svg": 93693,
	"./kuro-logo@1x.png": 48458,
	"./kuro-logo@2x.png": 15083,
	"./kuro-logo@3x.png": 57184,
	"./kuro-logo@4x.png": 28481,
	"./loga-logo-background@1x.png": 25731,
	"./loga-logo-background@2x.png": 67650,
	"./map-marker@1x.png": 83042,
	"./map-marker@2x.png": 41123,
	"./map-marker@3x.png": 33400,
	"./map-marker@4x.png": 56377,
	"./map-pin-slash@1x.png": 887,
	"./map-pin-slash@2x.png": 13270,
	"./map-pin-slash@3x.png": 17697,
	"./map-pin-slash@4x.png": 66464,
	"./map-pin-white-slash@1x.png": 22611,
	"./map-pin-white-slash@2x.png": 72082,
	"./map-pin-white-slash@3x.png": 46141,
	"./map-pin-white-slash@4x.png": 23764,
	"./map-pin-white@1x.png": 81215,
	"./map-pin-white@2x.png": 68382,
	"./map-pin-white@3x.png": 75081,
	"./map-pin-white@4x.png": 88264,
	"./map-pin@1x.png": 31923,
	"./map-pin@2x.png": 30418,
	"./map-pin@3x.png": 11773,
	"./map-pin@4x.png": 59252,
	"./mascot-rider-1@1x.png": 63185,
	"./mascot-rider-1@2x.png": 49116,
	"./mascot-rider-1@3x.png": 20615,
	"./mascot-rider-1@4x.png": 4090,
	"./menu_icon/default/ic-booking-dark.svg": 77969,
	"./menu_icon/default/ic-booking.svg": 73964,
	"./menu_icon/default/ic-coupons-dark.svg": 97097,
	"./menu_icon/default/ic-coupons.svg": 21492,
	"./menu_icon/default/ic-credits-dark.svg": 25184,
	"./menu_icon/default/ic-credits.svg": 70435,
	"./menu_icon/default/ic-facebook-white.svg": 84383,
	"./menu_icon/default/ic-facebook.svg": 11919,
	"./menu_icon/default/ic-helpdesk-dark.svg": 50302,
	"./menu_icon/default/ic-helpdesk.svg": 52117,
	"./menu_icon/default/ic-history-dark.svg": 36730,
	"./menu_icon/default/ic-history.svg": 43289,
	"./menu_icon/default/ic-info-dark.svg": 2520,
	"./menu_icon/default/ic-info.svg": 25163,
	"./menu_icon/default/ic-instagram-white.svg": 88121,
	"./menu_icon/default/ic-instagram.svg": 53797,
	"./menu_icon/default/ic-line-white.svg": 645,
	"./menu_icon/default/ic-line.svg": 66257,
	"./menu_icon/default/ic-lotto-dark.svg": 67684,
	"./menu_icon/default/ic-lotto.svg": 94015,
	"./menu_icon/default/ic-menu-dark.svg": 24891,
	"./menu_icon/default/ic-menu.svg": 43898,
	"./menu_icon/default/ic-rewards-dark.svg": 9606,
	"./menu_icon/default/ic-rewards.svg": 45517,
	"./menu_icon/default/ic-shop-dark.svg": 16436,
	"./menu_icon/default/ic-shop.svg": 94639,
	"./menu_icon/default/ic-subscription-dark.svg": 79237,
	"./menu_icon/default/ic-subscription.svg": 86648,
	"./menu_icon/default/ic-tiktok-white.svg": 43969,
	"./menu_icon/default/ic-tiktok.svg": 3549,
	"./menu_icon/default/ic-twitter-white.svg": 37000,
	"./menu_icon/default/ic-twitter.svg": 67240,
	"./menu_icon/default/ic-update-dark.svg": 29877,
	"./menu_icon/default/ic-update.svg": 87720,
	"./menu_icon/default/ic-website-white.svg": 23326,
	"./menu_icon/default/ic-website.svg": 65426,
	"./menu_icon/default/ic-wechat-white.svg": 54485,
	"./menu_icon/default/ic-wechat.svg": 84641,
	"./menu_icon/default/ic-youtube-white.svg": 58810,
	"./menu_icon/default/ic-youtube.svg": 62734,
	"./menu_icon/etc/comment-v2.svg": 69865,
	"./menu_icon/etc/comment.svg": 5656,
	"./menu_icon/etc/coupon-icon-2.svg": 97518,
	"./menu_icon/etc/coupon-icon.svg": 73291,
	"./menu_icon/etc/crown-white.svg": 11298,
	"./menu_icon/etc/crown.svg": 5862,
	"./menu_icon/etc/diamond.svg": 86487,
	"./menu_icon/etc/edit-white.svg": 1301,
	"./menu_icon/etc/edit.svg": 72449,
	"./menu_icon/etc/heart-outline-v2.svg": 84391,
	"./menu_icon/etc/heart-outline.svg": 83354,
	"./menu_icon/etc/heart-v2.svg": 29352,
	"./menu_icon/etc/heart.svg": 96543,
	"./menu_icon/etc/logout.svg": 16171,
	"./menu_icon/etc/map-pin-branch-primary.svg": 93717,
	"./menu_icon/etc/map-pin-branch.svg": 31184,
	"./menu_icon/etc/pin-black.svg": 16048,
	"./menu_icon/etc/pin-v2.svg": 8175,
	"./menu_icon/etc/pin.svg": 97474,
	"./menu_icon/etc/progress-star.svg": 86505,
	"./menu_icon/etc/qr-scan.svg": 27794,
	"./menu_icon/etc/qr-show.svg": 82398,
	"./menu_icon/etc/share-v2.svg": 59311,
	"./menu_icon/etc/share.svg": 514,
	"./menu_icon/etc/shop-delivering-inactive.svg": 26823,
	"./menu_icon/etc/shop-delivering.svg": 16867,
	"./menu_icon/etc/shop-done-inactive.svg": 72784,
	"./menu_icon/etc/shop-done.svg": 25134,
	"./menu_icon/etc/shop-paid-inactive.svg": 23682,
	"./menu_icon/etc/shop-paid.svg": 52744,
	"./menu_icon/etc/shop-preparing-inactive.svg": 27344,
	"./menu_icon/etc/shop-preparing.svg": 47502,
	"./menu_icon/etc/shop-rider.svg": 56354,
	"./menu_icon/etc/user-info.svg": 43717,
	"./menu_icon/etc/web.svg": 78301,
	"./menu_icon/hexagon/ic-booking-dark.svg": 80258,
	"./menu_icon/hexagon/ic-booking.svg": 48337,
	"./menu_icon/hexagon/ic-credits-dark.svg": 73295,
	"./menu_icon/hexagon/ic-credits.svg": 99862,
	"./menu_icon/hexagon/ic-helpdesk-dark.svg": 75451,
	"./menu_icon/hexagon/ic-helpdesk.svg": 6618,
	"./menu_icon/hexagon/ic-history-dark.svg": 86749,
	"./menu_icon/hexagon/ic-history.svg": 82048,
	"./menu_icon/hexagon/ic-info-dark.svg": 36633,
	"./menu_icon/hexagon/ic-info.svg": 82532,
	"./menu_icon/hexagon/ic-lotto-dark.svg": 75255,
	"./menu_icon/hexagon/ic-lotto.svg": 65998,
	"./menu_icon/hexagon/ic-menu-dark.svg": 16422,
	"./menu_icon/hexagon/ic-menu.svg": 82605,
	"./menu_icon/hexagon/ic-rewards-dark.svg": 65993,
	"./menu_icon/hexagon/ic-rewards.svg": 37556,
	"./menu_icon/hexagon/ic-shop-dark.svg": 61721,
	"./menu_icon/hexagon/ic-shop.svg": 12132,
	"./menu_icon/hexagon/ic-subscription-dark.svg": 6472,
	"./menu_icon/hexagon/ic-subscription.svg": 23227,
	"./menu_icon/hexagon/ic-update-dark.svg": 57680,
	"./menu_icon/hexagon/ic-update.svg": 5043,
	"./menu_icon/prod/1713/info.svg": 97901,
	"./menu_icon/prod/1713/menu.svg": 86476,
	"./menu_icon/prod/1713/youtube.svg": 43976,
	"./menu_icon/prod/2742/rewards.svg": 60016,
	"./menu_icon/prod/2742/website-jones@1x.png": 4402,
	"./menu_icon/prod/2742/website-jones@2x.png": 10259,
	"./menu_icon/prod/2742/website-jones@3x.png": 68680,
	"./menu_icon/prod/2742/website-jones@4x.png": 98473,
	"./menu_icon/prod/2742/website-lock@1x.png": 67940,
	"./menu_icon/prod/2742/website-lock@2x.png": 96889,
	"./menu_icon/prod/2742/website-lock@3x.png": 18382,
	"./menu_icon/prod/2742/website-lock@4x.png": 84035,
	"./menu_icon/prod/2742/website-loga.svg": 86511,
	"./menu_icon/prod/3810/coupons@1x.png": 34237,
	"./menu_icon/prod/3810/coupons@2x.png": 37960,
	"./menu_icon/prod/3810/coupons@3x.png": 70739,
	"./menu_icon/prod/3810/coupons@4x.png": 18078,
	"./menu_icon/prod/3810/helpdesk@1x.png": 36564,
	"./menu_icon/prod/3810/helpdesk@2x.png": 79625,
	"./menu_icon/prod/3810/helpdesk@3x.png": 56574,
	"./menu_icon/prod/3810/helpdesk@4x.png": 9235,
	"./menu_icon/prod/3810/rewards@1x.png": 74674,
	"./menu_icon/prod/3810/rewards@2x.png": 76179,
	"./menu_icon/prod/3810/rewards@3x.png": 43400,
	"./menu_icon/prod/3810/rewards@4x.png": 30217,
	"./menu_icon/prod/3810/shop@1x.png": 72206,
	"./menu_icon/prod/3810/shop@2x.png": 84687,
	"./menu_icon/prod/3810/shop@3x.png": 51908,
	"./menu_icon/prod/3810/shop@4x.png": 40077,
	"./menu_icon/prod/3810/website-loga@1x.png": 49147,
	"./menu_icon/prod/3810/website-loga@2x.png": 93754,
	"./menu_icon/prod/3810/website-loga@3x.png": 71941,
	"./menu_icon/prod/3810/website-loga@4x.png": 57180,
	"./menu_icon/prod/4213/website-loga.svg": 70776,
	"./menu_icon/prod/434/rewards@1x.png": 25537,
	"./menu_icon/prod/434/rewards@2x.png": 30380,
	"./menu_icon/prod/434/rewards@3x.png": 43351,
	"./menu_icon/prod/434/rewards@4x.png": 91594,
	"./menu_icon/test/1/rewards.svg": 91133,
	"./menu_icon/test/1/website-loga.svg": 34788,
	"./menu_icon/test/165/backup/website-jones-close-svg.svg": 71858,
	"./menu_icon/test/165/backup/website-jones-close.svg": 7599,
	"./menu_icon/test/165/backup/website-jones.svg": 35864,
	"./menu_icon/test/165/coupons@1x.png": 12778,
	"./menu_icon/test/165/coupons@2x.png": 18155,
	"./menu_icon/test/165/coupons@3x.png": 13280,
	"./menu_icon/test/165/coupons@4x.png": 79009,
	"./menu_icon/test/165/helpdesk@1x.png": 42117,
	"./menu_icon/test/165/helpdesk@2x.png": 85840,
	"./menu_icon/test/165/helpdesk@3x.png": 77979,
	"./menu_icon/test/165/helpdesk@4x.png": 40230,
	"./menu_icon/test/165/rewards@1x.png": 46793,
	"./menu_icon/test/165/rewards@2x.png": 99956,
	"./menu_icon/test/165/rewards@3x.png": 50207,
	"./menu_icon/test/165/rewards@4x.png": 52722,
	"./menu_icon/test/165/shop@1x.png": 39127,
	"./menu_icon/test/165/shop@2x.png": 35382,
	"./menu_icon/test/165/shop@3x.png": 56161,
	"./menu_icon/test/165/shop@4x.png": 74080,
	"./menu_icon/test/165/website-jones@1x.png": 24302,
	"./menu_icon/test/165/website-jones@2x.png": 72911,
	"./menu_icon/test/165/website-jones@3x.png": 16836,
	"./menu_icon/test/165/website-jones@4x.png": 28301,
	"./menu_icon/test/165/website-lock@1x.png": 43968,
	"./menu_icon/test/165/website-lock@2x.png": 58165,
	"./menu_icon/test/165/website-lock@3x.png": 35242,
	"./menu_icon/test/165/website-lock@4x.png": 86999,
	"./menu_icon/test/165/website-loga@1x.png": 5062,
	"./menu_icon/test/165/website-loga@2x.png": 76071,
	"./menu_icon/test/165/website-loga@3x.png": 20924,
	"./menu_icon/test/165/website-loga@4x.png": 53477,
	"./menu_icon/test/245/website-loga.svg": 96018,
	"./no-data@1x.png": 92673,
	"./no-data@2x.png": 44492,
	"./no-data@3x.png": 80759,
	"./no-data@4x.png": 29002,
	"./promptpay@1x.png": 48171,
	"./promptpay@2x.png": 59146,
	"./promptpay@3x.png": 24597,
	"./promptpay@4x.png": 54956,
	"./qr-error.svg": 38494,
	"./qr-sample@1x.png": 31351,
	"./qr-sample@2x.png": 43734,
	"./qr-sample@3x.png": 48161,
	"./qr-sample@4x.png": 96928,
	"./qr-search@1x.png": 87269,
	"./qr-search@2x.png": 30992,
	"./qr-search@3x.png": 6779,
	"./qr-search@4x.png": 69030,
	"./thai-qr-mask@1x.png": 21804,
	"./thai-qr-mask@2x.png": 65377,
	"./thai-qr-mask@3x.png": 44598,
	"./thai-qr-mask@4x.png": 57547,
	"./thai-qr@1x.png": 91517,
	"./thai-qr@2x.png": 95240,
	"./thai-qr@3x.png": 28019,
	"./thai-qr@4x.png": 75358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;